var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaratRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.4 1.678L1.828.25 6.578 5l-4.75 4.75L.4 8.323 3.723 5z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3IiBoZWlnaHQ9IjEwIiBmaWxsPSIjMDA2ZWFkIj4KICAgIDxwYXRoIGQ9Ik0uNCAxLjY3OEwxLjgyOC4yNSA2LjU3OCA1bC00Ljc1IDQuNzVMLjQgOC4zMjMgMy43MjMgNXoiIGZpbGw9IiMwMDZlYWQiIC8+Cjwvc3ZnPgo=";
export { SvgCaratRightSmall as ReactComponent };